/** `/:slug/atendimento` e subpáginas (PRAT-64). */
export function isAtendimentoPath(pathname: string): boolean {
  return /^\/[^/]+\/atendimento(\/|$)/.test(pathname);
}
